import { Tooltip } from 'antd';
import React from 'react';
import { useEffect, useRef, useState } from 'react';
export default function (props) {
    const { children } = props;
    const [ellipsis, setEllipsis] = useState(false);
    const boxRef = useRef();
    useEffect(() => {
        const autoEllipsis = () => {
            var _a, _b, _c, _d;
            if (((_a = boxRef === null || boxRef === void 0 ? void 0 : boxRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) && ((_b = boxRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth)) {
                if (((_c = boxRef === null || boxRef === void 0 ? void 0 : boxRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) > ((_d = boxRef.current) === null || _d === void 0 ? void 0 : _d.clientWidth)) {
                    setEllipsis(true);
                }
                else {
                    setEllipsis(previousState => {
                        return previousState;
                    });
                }
            }
        };
        const observer = new ResizeObserver(autoEllipsis);
        observer.observe(boxRef.current);
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [children]);
    if (!ellipsis) {
        return (React.createElement("div", { ref: boxRef, key: "box-ref", style: { overflow: 'auto hidden', whiteSpace: 'nowrap', width: '100%' } }, children));
    }
    else {
        return (React.createElement(Tooltip, { title: children, overlayStyle: { pointerEvents: 'none' } },
            React.createElement("div", { ref: boxRef, key: "box-ref", style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                } }, children)));
    }
}
//# sourceMappingURL=index.js.map